import { LESSON_MINUTES, WEEKS } from "../data/transmissao";

const MIN = 60000;

const minutesOf = (time) => {
  const m = time.match(/(\d+)h(\d+)?/);
  return Number(m[1]) * 60 + Number(m[2] || 0);
};

export const dayStart = (date) => new Date(`${date}T00:00:00-03:00`).getTime();
export const dayEnd = (date) => new Date(`${date}T23:59:59-03:00`).getTime();
export const slotStart = (date, time) => dayStart(date) + minutesOf(time) * MIN;

// Todos os aulões em ordem, com início/fim e posição do dia (1..8) na playlist.
export const ALL_SLOTS = WEEKS.flatMap((w, wi) =>
  w.days.flatMap((d, di) =>
    d.slots.map(([time, prof, disc, guest]) => {
      const start = slotStart(d.date, time);
      return { week: wi, dayIndex: di, date: d.date, dow: d.dow, label: d.label, time, prof, disc, guest: !!guest, start, end: start + LESSON_MINUTES * MIN };
    })
  )
);

export const DAY_ORDER = WEEKS.flatMap((w) => w.days.map((d) => d.date));

export const liveSlot = (now) => ALL_SLOTS.find((s) => now >= s.start && now < s.end) || null;
export const nextSlot = (now) => ALL_SLOTS.find((s) => s.start > now) || null;

export const slotState = (slot, now) => ({
  isLive: now >= slot.start && now < slot.end,
  isPast: now >= slot.end,
});

// O material do dia libera às 00h do dia do aulão, antes da live.
export const materialAt = (day) => dayStart(day.date);

// A gravação libera quando termina o último aulão do dia.
export const unlockAt = (day) => {
  const last = day.slots[day.slots.length - 1][0];
  return slotStart(day.date, last) + LESSON_MINUTES * MIN;
};

export const dayState = (day, now) => {
  const past = dayEnd(day.date) < now;
  const today = dayStart(day.date) <= now && !past;
  return { past, today };
};

// Semana/dia em destaque: o primeiro dia que ainda não acabou.
export const currentPosition = (now) => {
  for (let w = 0; w < WEEKS.length; w++) {
    for (let d = 0; d < WEEKS[w].days.length; d++) {
      if (dayEnd(WEEKS[w].days[d].date) >= now) return { week: w, day: d };
    }
  }
  return { week: WEEKS.length - 1, day: 0 };
};

export const todayDay = (now) => {
  const today = new Date(now - 3 * 3600000).toISOString().slice(0, 10);
  for (const w of WEEKS) for (const d of w.days) if (d.date === today) return d;
  return null;
};

// Aceita ID de 11 caracteres ou qualquer link do YouTube.
export const youtubeIdOf = (value) => {
  const v = (value || "").trim();
  const m = v.match(/(?:v=|youtu\.be\/|embed\/|live\/)([\w-]{11})/);
  if (m) return m[1];
  return /^[\w-]{11}$/.test(v) ? v : "";
};

export const playlistIdOf = (value) => {
  const v = (value || "").trim();
  const m = v.match(/list=([\w-]+)/);
  return m ? m[1] : v;
};
